import { useRoutes } from '@/shared/routes';

export const basketRoutes = [
  {
    path: useRoutes.BASKET_LIST_PATH,
    name: useRoutes.BASKET_LIST_NAME,
    component: () => import('@/pages/Basket'),
  },
];
